import React, { PureComponent } from 'react';
import { styled } from 'linaria/react';

import { ReactComponent as Mars } from '../../svg/mars.svg';
import { ReactComponent as Venus } from '../../svg/venus.svg';

const StoreDetailsStyle = styled('div')`
  border-bottom: 1px solid #eaeaea;
  margin-top: 3.5rem;
  margin-right: 0.5rem;
  min-height: 200px;
  padding: 0 2rem 1rem 2rem;
  width: 250px;

  h2 {
    font-size: 1.25rem;
    font-weight: 300;
    letter-spacing: 0.25px;
    margin-bottom: 0.5rem;
  }

  address {
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 1.6;
  }

  a {
    color: #999;
    text-decoration: none;
    transition: all ease 0.3s;
    :hover {
      color: #000;
    }
  }
`;

const Gender = styled('div')`
  p {
    display: inline-block;
    text-align: center;
    width: fit-content;
    :first-of-type {
      margin-right: 10px;
    }
  }
  span {
    display: block;
    font-size: 11px;
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export default class StoreDetail extends PureComponent {
  render() {
    const { store } = this.props;

    return (
      <StoreDetailsStyle>
        <h2>{store.name}</h2>
        {store.description && (
          <>
            <Gender>
              {store.description.toLowerCase().includes('h') && (
                <p>
                  <Mars />
                  <span>Herr</span>
                </p>
              )}
              {store.description.toLowerCase().includes('d') && (
                <p>
                  <Venus />
                  <span>Dam</span>
                </p>
              )}
            </Gender>
          </>
        )}
        {store.address1 && (
          <address>
            <div dangerouslySetInnerHTML={{ __html: store.address1 }} />
            {store.address2 && (
              <div dangerouslySetInnerHTML={{ __html: store.address2 }} />
            )}
          </address>
        )}
      </StoreDetailsStyle>
    );
  }
}
